module.exports = __webpack_public_path__ + "media/vid3.e34c6523.mp4";